import { ACTION_TYPES } from "./types"
import { Project } from "../models"

export const Action = {
    fetch: (payload: string) => {
        return {
            type: ACTION_TYPES.FETCH,
            payload: payload,
        }
    },

    fetchSuccess: (payload: Project) => {
        return {
            type: ACTION_TYPES.FETCH_SUCCESS,
            payload: payload,
        }
    },
}






// WEBPACK FOOTER //
// ./src/state/project/actions/actions.ts